import { render, staticRenderFns } from "./Step13.vue?vue&type=template&id=12c107a0&scoped=true"
import script from "./Step13.vue?vue&type=script&lang=js"
export * from "./Step13.vue?vue&type=script&lang=js"
import style0 from "./Step13.vue?vue&type=style&index=0&id=12c107a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c107a0",
  null
  
)

export default component.exports